import { TrackingHistoryContext } from 'context/tracking_history';
import { useContextSelector } from 'use-context-selector';

export function useLoadingHistorico() {
  const loadingHistorico = useContextSelector(
    TrackingHistoryContext,
    context => context.loadingHistorico
  );

  return {
    loadingHistorico,
  };
}

